// CRM-owned addresses are hidden in the roster editor. Do not validate or
// resubmit them when saving website settings; an empty list leaves them intact.
export const getAgentAddressesForSave = (agent) => (agent.brivityUsersId ? [] : agent.addresses);
export const getAgentPhonesForSave = (agent) => (agent.brivityUsersId ? [] : agent.phones);
export const getAgentEmailsForSave = (agent, isAdmin) => (agent.brivityUsersId && !isAdmin ? [] : agent.emails);

const errorTabs = {
  firstName: "agent-about",
  lastName: "agent-about",
  phones: "agent-about",
  emails: "agent-about",
  addresses: "agent-about",
  testimonials: "agent-testimonials",
  social: "agent-social",
};

export const getErrorTab = (errors, activeTab) => {
  const tabs = Object.keys(errors).map((key) => errorTabs[key]).filter(Boolean);
  return tabs.length === 0 || tabs.includes(activeTab) ? activeTab : tabs[0];
};
